import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import Button from '@shared/components/core/button/CoreButton';
import TextButton from '@shared/components/core/button/TextButton';
import CardCenteredContent from '@shared/components/core/card/CardCenteredContent';
import CardIcon from '@shared/components/core/card/CardIcon';
import { CardSmallGrid } from '@shared/components/core/card/CommonCardLayouts';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import SdkOptionsGrid from '@shared/components/support/SdkOptionsRow';
import { useTranslation } from 'react-i18next';

export default function DeveloperToolsPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader
                title={t('common:developer.titleLong')}
                description={t('common:developer.description')}
                items={items}
            />
            <SubSectionRow
                title={t('common:developer.sdk.title')}
                description={t('common:developer.sdk.description')}
            />
            <SdkOptionsGrid />

            <SubSectionRow
                title={t('common:developer.demo.samples')}
                description={t('common:developer.demo.description')}
            />
            <CardSmallGrid>
                <CardIcon
                    name="code"
                    title={t('common:developer.demo.docs.title')}
                    description={t('common:developer.demo.docs.description')}>
                    <TextButton endIcon="externalLink" variant="subsection" href="https://developers.cephable.com/">
                        {t('common:developer.demo.docs.action')}
                    </TextButton>
                </CardIcon>
                <CardIcon
                    name="globe"
                    title={t('common:developer.demo.web.title')}
                    description={t('common:developer.demo.web.description')}>
                    <TextButton endIcon="externalLink" variant="subsection" href="https://web-samples.cephable.com/">
                        {t('common:developer.demo.web.action')}
                    </TextButton>
                </CardIcon>
                <CardIcon
                    name="unity"
                    title={t('common:developer.demo.unity.title')}
                    description={t('common:developer.demo.unity.description')}>
                    <TextButton
                        endIcon="externalLink"
                        variant="subsection"
                        href="https://github.com/Cephable/Cephable-Unity-Samples">
                        {t('common:developer.demo.unity.action')}
                    </TextButton>
                </CardIcon>

                <CardIcon
                    name="multipleDevices"
                    title={t('common:developer.demo.other.title')}
                    description={t('common:developer.demo.other.description')}>
                    <TextButton endIcon="externalLink" variant="subsection" href="https://github.com/Cephable">
                        {t('common:developer.demo.other.action')}
                    </TextButton>
                </CardIcon>
            </CardSmallGrid>
            <SubSectionRow
                title={t('common:developer.other.title')}
                description={t('common:developer.other.description')}
            />
            <CardSmallGrid>
                <CardIcon
                    name="code"
                    title={t('common:developer.other.api.title')}
                    description={t('common:developer.other.api.description')}>
                    <TextButton
                        endIcon="externalLink"
                        variant="subsection"
                        href="https://services.cephable.com/swagger/index.html">
                        Learn More
                    </TextButton>
                </CardIcon>
                <CardCenteredContent
                    name="help"
                    title={t('common:developer.other.support.title')}
                    description={t('common:developer.other.support.description')}>
                    <Button $color="secondary" href="https://discord.gg/YSDpstxXb5" startIcon="plusLight">
                        {t('common:developer.other.support.action')}
                    </Button>
                </CardCenteredContent>
            </CardSmallGrid>
        </>
    );
}
